export const STUDENT_ROLE_ID = 4;

/**
 * base on library/Acl/Role.php
 */
export const ROLES = {
  GUEST: 'guest',

  ANONYMOUS: 'anonymous',
  CANDIDATE: 'candidate',
  CANDIDATE_PREMIUM: 'candidate-premium',
  CANDIDATE_PREMIUM_PREP: 'candidate-premium-with-preparatory',
  CANDIDATE_WITH_RECRUITER_POSITION: 'CandidateWithRecruiterPosition',

  RECRUITER: 'recruiter',
  RECRUITER_DEFAULT: 'recruiter-default',
  RECRUITER_BASIC: 'recruiter-basic',
  RECRUITER_PREMIUM: 'recruiter-premium',
  RECRUITER_PREMIUM_REC_FIRM: 'recruiter-premium-recruiting-firm',
  RECRUITER_RESTRICTED: 'recruiter-restricted',
  RECRUITER_GBS: 'recruiter-gobuyside',
  RECRUITER_GBS_MASTER_ACCOUNT: 'recruiter-gobuyside-master-account',
};
export default ROLES;
